import SidebarCollapse from "@builder/components/app/SidebarCollapse";
import { EditableProps } from "@builder/components/editable/editableProps";
import { getStyle, getStylePath } from "@builder/components/editable/helpers";
import Background from "@builder/components/editable/style/Background";
import Borders from "@builder/components/editable/style/Borders";
import Size from "@builder/components/editable/style/Size";
import Typography from "@builder/components/editable/style/Typography";
import { getValueUnit } from "@builder/components/general/editUtils";
import OliverText from "@builder/components/general/OliverText";
import SliderInput from "@builder/components/general/SliderInput";
import { getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { updateNodeProperty } from "@builder/store/slices/BuilderSlice/builderSlice";
import { useAppDispatch, useAppSelector } from "@builder/store/store";

const TextInput = ({ title, parent, path, excluded, stateMode }: EditableProps) => {
    const dispatch = useAppDispatch();
    const node = useAppSelector(getSelectedNode);
    const cvMode = useAppSelector(state => state.builder.conditionalVariationMode);
    const cvModeIndex = cvMode?.id === node?.id ? cvMode.index : null;

    if (!node) return null;

    const style = getStyle(node, path, stateMode, cvModeIndex);
    const stylePath = getStylePath(path, stateMode, cvModeIndex);

    // Gap
    let marginLeftElem = null;
    if (!excluded?.includes("marginLeft")) {
        const gapString = style.stateStyle?.marginInlineStart || (style.default?.marginInlineStart as string | undefined);
        const gap = getValueUnit(gapString);
        const gapCallback = (value: string, unit: string) => {
            dispatch(
                updateNodeProperty({
                    propertyPath: [...stylePath, "marginInlineStart"],
                    value: value + unit
                })
            );
        };
        marginLeftElem = <SliderInput title="Gap" {...gap} min={0} max={30} callback={gapCallback} />;
    }

    return (
        <SidebarCollapse title={title || "Text Input"} parent={parent}>
            <Typography noWrapper path={path} stateMode={stateMode} />

            {!excluded?.includes("background") && (
                <>
                    <OliverText
                        text="Background"
                        size="xs"
                        weight="medium-heavy"
                        translatePrefix="sidebarCollapse."
                        style={{ margin: "8px 0 -6px 0" }}
                    />
                    <Background noWrapper path={path} stateMode={stateMode} />
                </>
            )}
            {!excluded?.includes("borders") && (
                <>
                    <OliverText
                        text="Borders"
                        size="xs"
                        weight="medium-heavy"
                        translatePrefix="sidebarCollapse."
                        style={{ margin: "8px 0 -6px 0" }}
                    />
                    <Borders noWrapper path={path} stateMode={stateMode} />
                </>
            )}
            {!excluded?.includes("size") && (
                <>
                    <OliverText text="Size" size="xs" weight="medium-heavy" translatePrefix="sidebarCollapse." style={{ margin: "8px 0 -6px 0" }} />
                    <Size noWrapper path={path} excluded={excluded?.includes("sizeWidth") ? ["width"] : undefined} stateMode={stateMode} />
                </>
            )}
            {marginLeftElem}
        </SidebarCollapse>
    );
};

export default TextInput;
